import * as Immutable from "immutable"
import { BaseEntity } from "../../../../pages/shared/baseEntity";
import { ListItem, ColoredInterval } from "..";

export class AritcoResponse extends BaseEntity {

  protected readonly SUCCESS = "success";
  protected readonly MESSAGE = "message";
  protected readonly DONE = "done";
  protected readonly ITEMS = "items";
  protected readonly UNSELECTABLE_INTERVALS = "unselectableIntervals";
  protected readonly COLORED_INTERVALS = "coloredIntervals";

  get message(): string { return this.getInternalValue<string>(this.MESSAGE); }
  setMessage(message: string): this { return this.setInternalValue(this.MESSAGE, message); }

  get success(): boolean { return this.getInternalValue<boolean>(this.SUCCESS); }
  setSuccess(success: boolean): this { return this.setInternalValue(this.SUCCESS, success); }

  get done(): boolean { return this.getInternalValue<boolean>(this.DONE); }
  setDone(done: boolean): this { return this.setInternalValue(this.DONE, done); }

  get items(): Immutable.List<ListItem> { return this.getInternalValue<Immutable.List<ListItem>>(this.ITEMS); }
  setItems(items: Immutable.List<ListItem>): this { return this.setInternalValue(this.ITEMS, items); }

  get unselectableIntervals(): Immutable.List<ColoredInterval> { return this.getInternalValue<Immutable.List<ColoredInterval>>(this.UNSELECTABLE_INTERVALS); }
  setUnselectableIntervals(unselectableIntervals: Immutable.List<ColoredInterval>): this { return this.setInternalValue(this.UNSELECTABLE_INTERVALS, unselectableIntervals); }

  get coloredIntervals(): Immutable.List<ColoredInterval> { return this.getInternalValue<Immutable.List<ColoredInterval>>(this.COLORED_INTERVALS); }
  setColoredIntervals(coloredIntervals: Immutable.List<ColoredInterval>): this { return this.setInternalValue(this.COLORED_INTERVALS, coloredIntervals); }

}